import React from 'react';
import { Card, Typography } from 'antd';
import SignInForm from './SignInForm';
import './SignInPage.scss';
import { useTranslation } from '../../i18n/i18n';

const { Title } = Typography;

const SignInPage = () => {
  const { t } = useTranslation('auth');
  return (
    <div className={'SignIn'}>
      <Card title="" className={'SignIn__CardLogin'}>
        <div className={'SignIn__CardLogin__TitleCard'}>
          <Title level={1} className={'SignIn__CardLogin__TitleCard__Title Title'}>
            {t('welcome')}
          </Title>
          <img src={'/assets/images/KAIROS-negre.png'} alt={'Kairos'} className={'IdentityComponent__img'} />
        </div>
        <SignInForm />
      </Card>
    </div>
  );
};

export default SignInPage;
